import "../App.css";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../config";

import "@fontsource/open-sans";
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/400-italic.css";

import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { toast } from "wc-toast";
import { connect } from "react-redux";
import { SetId } from "./redux/actions";

import logo from "../logo1.png";
import aboutFormImage from "../new1.png";

function Free_trials({ SetId }) {
  const navigate = useNavigate();

  // ================= OLD COMPATIBILITY STATES =================
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [newpass, setNewpass] = useState("");

  const [show, setShow] = useState(true);
  const [reshow, setReShow] = useState(true);
  const [accept, setAccept] = useState(false);
  const [shown, setShown] = useState(false);

  // ================= STEP CONTROL =================
  const [step, setStep] = useState(1);

  // ================= STEP 1 FIELDS =================
  const [organizationName, setOrganizationName] = useState("");
  const [industry, setIndustry] = useState("");
  const [country, setCountry] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneCode, setPhoneCode] = useState("+44");

  // ================= INDUSTRY DROPDOWN =================
  const [industryOpen, setIndustryOpen] = useState(false);
  const [industrySearch, setIndustrySearch] = useState("");

  const industryInputRef = useRef(null);
  const countryInputRef = useRef(null);

  const industryOptions = [
    "Retail Store",
    "Restaurants",
    "Gym & Fitness",
    "Corporate Office",
    "Hotels & Hospitality",
    "Shopping Malls",
    "Estate Agency",
    "Car Showrooms",
    "School & University",
    "Clinics & Healthcare",
    "Others",
  ];

  const filteredIndustryOptions = industryOptions.filter((item) =>
    item.toLowerCase().includes(industrySearch.toLowerCase())
  );

  // ================= COUNTRY DROPDOWN =================
  const [countryOpen, setCountryOpen] = useState(false);
  const [countrySearch, setCountrySearch] = useState("");

  const countryOptions = [
    { name: "Australia", code: "+61", flag: "🇦🇺" },
    { name: "Bahrain", code: "+973", flag: "🇧🇭" },
    { name: "Bangladesh", code: "+880", flag: "🇧🇩" },
    { name: "Belgium", code: "+32", flag: "🇧🇪" },
    { name: "Brazil", code: "+55", flag: "🇧🇷" },
    { name: "Canada", code: "+1", flag: "🇨🇦" },
    { name: "China", code: "+86", flag: "🇨🇳" },
    { name: "Denmark", code: "+45", flag: "🇩🇰" },
    { name: "France", code: "+33", flag: "🇫🇷" },
    { name: "Germany", code: "+49", flag: "🇩🇪" },
    { name: "India", code: "+91", flag: "🇮🇳" },
    { name: "Ireland", code: "+353", flag: "🇮🇪" },
    { name: "Italy", code: "+39", flag: "🇮🇹" },
    { name: "Japan", code: "+81", flag: "🇯🇵" },
    { name: "Kuwait", code: "+965", flag: "🇰🇼" },
    { name: "Malaysia", code: "+60", flag: "🇲🇾" },
    { name: "Mexico", code: "+52", flag: "🇲🇽" },
    { name: "Netherlands", code: "+31", flag: "🇳🇱" },
    { name: "New Zealand", code: "+64", flag: "🇳🇿" },
    { name: "Nigeria", code: "+234", flag: "🇳🇬" },
    { name: "Norway", code: "+47", flag: "🇳🇴" },
    { name: "Oman", code: "+968", flag: "🇴🇲" },
    { name: "Pakistan", code: "+92", flag: "🇵🇰" },
    { name: "Qatar", code: "+974", flag: "🇶🇦" },
    { name: "Saudi Arabia", code: "+966", flag: "🇸🇦" },
    { name: "Singapore", code: "+65", flag: "🇸🇬" },
    { name: "South Africa", code: "+27", flag: "🇿🇦" },
    { name: "South Korea", code: "+82", flag: "🇰🇷" },
    { name: "Spain", code: "+34", flag: "🇪🇸" },
    { name: "Sweden", code: "+46", flag: "🇸🇪" },
    { name: "Switzerland", code: "+41", flag: "🇨🇭" },
    { name: "Turkey", code: "+90", flag: "🇹🇷" },
    { name: "United Arab Emirates", code: "+971", flag: "🇦🇪" },
    { name: "United Kingdom", code: "+44", flag: "🇬🇧" },
    { name: "United States", code: "+1", flag: "🇺🇸" },
  ].sort((a, b) => a.name.localeCompare(b.name));

  const filteredCountryOptions = countryOptions
    .filter((item) =>
      item.name.toLowerCase().includes(countrySearch.toLowerCase())
    )
    .sort((a, b) => a.name.localeCompare(b.name));

  // ================= OLD FIREBASE LOGIC =================
  async function createUserInFirebase(userEmail, userPassword) {
    let result = false;
    try {
      result = await auth.createUserWithEmailAndPassword(userEmail, userPassword);

      if (result) {
        console.log("User signed in successfully");
        return true;
      } else {
        toast.error("Incorrect email or password. Please try again.");
        return false;
      }
    } catch (error) {
      console.error("Error signing in:", error);
      if (error.message.includes("already in use")) {
        toast.error("Email already in use. Please try another email.");
      } else {
        toast.error("Email is invalid. Please try again.");
      }
      return false;
    }
  }

  async function Sign_up_Function() {
    if (
      pass === newpass &&
      name !== "" &&
      email !== "" &&
      pass !== "" &&
      newpass !== "" &&
      isValidEmail(email) &&
      first &&
      second &&
      third &&
      four &&
      fifth &&
      accept
    ) {
      const room = db.ref("Sign_up");
      const ID = new Date().getTime();

      const res = await createUserInFirebase(email.toLowerCase(), pass);

      if (res !== true) {
        return;
      } else {
        await auth.signInWithEmailAndPassword(
          "n.joy@boomsoftware.co.uk",
          "2103199j"
        );

        const obj = {
          Email: email.toLowerCase(),
          Name: name,
          Password: pass,
          id: ID,
          device_no: 0,
          OrganizationName: organizationName,
          Industry: industry,
          Country: country,
          CountryCode: phoneCode,
          FirstName: firstName,
          LastName: lastName,
          Phone: phone,
        };

        await room.child(String(ID)).set(obj);

        const folder_obj = {
          ID: new Date().getTime(),
          name: "vnwchgf",
        };

        const userdb = db.ref("userdb");
        await userdb
          .child(String(ID))
          .child("folder")
          .child(String(folder_obj.ID))
          .set(folder_obj);

        localStorage.setItem("display", JSON.stringify(obj));
        SetId(obj);
        toast.success("Information has been submitted successfully.");
        navigate("/");
      }
    } else {
      if (!isValidEmail(email)) {
        toast.error("Please complete your email address.");
      } else if (newpass !== pass) {
        toast.error("Password does not match");
      } else if (!(first && second && third && four && fifth)) {
        toast.error("Password is not strong");
      } else if (!accept) {
        toast.error("Please agree to Terms & Conditions.");
      } else {
        toast.error("Missing information");
      }
    }
  }

  // ================= RESPONSIVE =================
  const [width, setwidth] = useState(window.innerWidth);
  const [height, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const windowSizeHandler = () => {
      setwidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", windowSizeHandler);
    return () => {
      window.removeEventListener("resize", windowSizeHandler);
    };
  }, []);

  const isMobile = width <= 900;

  // ================= PASSWORD RULES =================
  function containsSpecialCharacter(str) {
    const specialCharsRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/;
    return specialCharsRegex.test(str);
  }

  const [first, setFirst] = useState(false);
  const [second, setSecond] = useState(false);
  const [third, setThird] = useState(false);
  const [four, setFour] = useState(false);
  const [fifth, setFifth] = useState(false);

  useEffect(() => {
    if (
      pass.includes(0) ||
      pass.includes(1) ||
      pass.includes(2) ||
      pass.includes(3) ||
      pass.includes(4) ||
      pass.includes(5) ||
      pass.includes(6) ||
      pass.includes(7) ||
      pass.includes(8) ||
      pass.includes(9)
    ) {
      setFour(true);
    } else {
      setFour(false);
    }

    if (hasLowerCase(pass)) {
      setThird(true);
    } else {
      setThird(false);
    }

    if (hasUpperCase(pass)) {
      setSecond(true);
    } else {
      setSecond(false);
    }

    if (pass.length >= 7) {
      setFirst(true);
    } else {
      setFirst(false);
    }

    if (containsSpecialCharacter(pass)) {
      setFifth(true);
    } else {
      setFifth(false);
    }
  }, [pass]);

  function hasLowerCase(str) {
    return str.toUpperCase() !== str;
  }

  function hasUpperCase(str) {
    return str.toLowerCase() !== str;
  }

  const isValidEmail = (emailValue) => {
    if (emailValue === "") return true;
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    return emailRegex.test(emailValue);
  };

  // ================= STEP 1 NEXT =================
  const handleStepOneNext = () => {
    if (
      organizationName.trim() === "" ||
      industry.trim() === "" ||
      country.trim() === "" ||
      firstName.trim() === "" ||
      lastName.trim() === "" ||
      phone.trim() === ""
    ) {
      toast.error("Please fill all required information.");
      return;
    }

    setName(`${firstName.trim()} ${lastName.trim()}`);
    setStep(2);
  };

  // ================= STEP 2 SUBMIT =================
  const handleFinalSubmit = () => {
    if (email.trim() === "" || pass.trim() === "" || newpass.trim() === "") {
      toast.error("Please fill all required information.");
      return;
    }

    if (!isValidEmail(email)) {
      toast.error("Please complete your email address.");
      return;
    }

    if (pass !== newpass) {
      toast.error("Password does not match");
      return;
    }

    if (!(first && second && third && four && fifth)) {
      toast.error("Password is not strong");
      return;
    }

    setName(`${firstName.trim()} ${lastName.trim()}`);
    Sign_up_Function();
  };

  // ================= UI HELPERS =================
  const cardRadius = isMobile ? 18 : 22;
  const inputHeight = isMobile ? 56 : 58;
  const fieldBg = "#1E1207";
  const fieldBorder = "1px solid rgba(247,148,29,0.18)";
  const fieldText = "#EDEDED";
  const fieldPlaceholder = "#8D7F72";

  const inputStyle = {
    width: "100%",
    height: inputHeight,
    borderRadius: 10,
    background: fieldBg,
    border: fieldBorder,
    outline: "none",
    paddingLeft: 20,
    paddingRight: 20,
    color: fieldText,
    fontSize: isMobile ? 16 : 17,
    fontWeight: 400,
    fontFamily: "Open Sans",
    boxSizing: "border-box",
  };

  const labelTextStyle = {
    width: "100%",
    textAlign: "left",
    color: "#EAEAEA",
    fontSize: isMobile ? 16 : 17,
    fontWeight: 400,
    fontFamily: "Open Sans",
    marginTop: 18,
    marginBottom: 10,
  };

  const plainInputStyle = {
    width: "100%",
    height: inputHeight,
    borderRadius: 10,
    backgroundColor: "#DDF1F2",
    outline: "none",
    border: "1px solid #2CC7C7",
    color: "#6E6680",
    fontSize: isMobile ? 18 : 19,
    fontWeight: 400,
    paddingLeft: 18,
    paddingRight: 18,
    fontFamily: "Open Sans",
    boxSizing: "border-box",
  };

  const passwordInputWrapStyle = {
    width: "100%",
    height: inputHeight,
    marginTop: 18,
    borderRadius: 10,
    backgroundColor: "#DDF1F2",
    border: "1px solid #2CC7C7",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    paddingLeft: 18,
    paddingRight: 16,
  };

  useEffect(() => {
    if (industryOpen) {
      setTimeout(() => {
        industryInputRef.current?.focus();
      }, 60);
    }
  }, [industryOpen]);

  useEffect(() => {
    if (countryOpen) {
      setTimeout(() => {
        countryInputRef.current?.focus();
      }, 60);
    }
  }, [countryOpen]);

  useEffect(() => {
    const handleClickOutside = () => {
      setIndustryOpen(false);
      setCountryOpen(false);
    };

    if (industryOpen || countryOpen) {
      window.addEventListener("click", handleClickOutside);
    }

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [industryOpen, countryOpen]);

  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        background: "#04080D",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: isMobile ? "16px" : "18px",
        boxSizing: "border-box",
      }}
    >
      <wc-toast></wc-toast>

      <div
        style={{
          width: "100%",
          maxWidth: 1600,
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1.35fr 0.95fr",
          gap: isMobile ? 18 : 28,
          alignItems: "stretch",
        }}
      >
        {/* ================= LEFT IMAGE PANEL ================= */}
        <div
          style={{
            position: "relative",
            minHeight: isMobile ? 300 : 860,
            borderRadius: cardRadius,
            overflow: "hidden",
          }}
        >
          <img
            src={aboutFormImage}
            alt="Boom Display"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              display: "block",
              position: "absolute",
              inset: 0,
            }}
          />
        </div>

        {/* ================= RIGHT FORM PANEL ================= */}
        <div
          style={{
            width: "100%",
            minHeight: isMobile ? "auto" : 860,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            paddingTop: isMobile ? 4 : 26,
            paddingBottom: isMobile ? 10 : 26,
            boxSizing: "border-box",
          }}
        >
          {step === 1 ? (
            <>
              <div
                style={{
                  color: "#D8D8D8",
                  fontSize: isMobile ? 16 : 17,
                  fontWeight: 400,
                  fontFamily: "Open Sans",
                  lineHeight: "26px",
                }}
              >
                Get <span style={{ color: "#F7941D", fontWeight: 700 }}>7 days</span> free trial.
              </div>

              <div
                style={{
                  marginTop: 10,
                  color: "#FFFFFF",
                  fontSize: isMobile ? 34 : 42,
                  fontWeight: 700,
                  fontFamily: "Open Sans",
                  lineHeight: isMobile ? "42px" : "50px",
                }}
              >
                Hi, 👋
              </div>

              <div
                style={{
                  marginTop: 10,
                  maxWidth: 520,
                  color: "#8F8A97",
                  fontSize: isMobile ? 16 : 18,
                  fontWeight: 400,
                  fontFamily: "Open Sans",
                  lineHeight: isMobile ? "28px" : "34px",
                }}
              >
                Before you get start quickly tell us a little about your organisation.
                This will help us create the right experience for you.
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  marginTop: isMobile ? 24 : 28,
                  marginBottom: isMobile ? 28 : 30,
                }}
              >
                <div
                  style={{
                    flex: 1,
                    height: 6,
                    borderRadius: 999,
                    background: "#F7941D",
                  }}
                />
                <div
                  style={{
                    flex: 1,
                    height: 6,
                    borderRadius: 999,
                    background: "#EAEAEA",
                  }}
                />
              </div>

              <input
                placeholder="Organisation Name"
                style={inputStyle}
                value={organizationName}
                onChange={(e) => setOrganizationName(e.target.value)}
              />

              {/* ================= INDUSTRY FIELD ================= */}
              <div
                style={{ width: "100%", position: "relative", marginTop: 18, zIndex: industryOpen ? 30 : 1 }}
                onClick={(e) => e.stopPropagation()}
              >
                <div
                  style={{
                    ...inputStyle,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    userSelect: "none",
                    position: "relative",
                    overflow: "hidden",
                  }}
                  onClick={() => {
                    if (!industryOpen) {
                      setIndustryOpen(true);
                      setCountryOpen(false);
                    }
                  }}
                >
                  {industryOpen ? (
                    <input
                      ref={industryInputRef}
                      placeholder="Search industry"
                      value={industrySearch}
                      onChange={(e) => setIndustrySearch(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        flex: 1,
                        height: "100%",
                        border: "none",
                        outline: "none",
                        background: "transparent",
                        color: "#EDEDED",
                        fontSize: isMobile ? 16 : 17,
                        fontFamily: "Open Sans",
                        paddingRight: 12,
                      }}
                    />
                  ) : (
                    <span
                      style={{
                        color: industry ? fieldText : fieldPlaceholder,
                        fontSize: isMobile ? 16 : 17,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {industry || "Industry"}
                    </span>
                  )}

                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      setIndustryOpen(!industryOpen);
                      if (!industryOpen) {
                        setCountryOpen(false);
                      } else {
                        setIndustrySearch("");
                      }
                    }}
                    style={{
                      minWidth: 28,
                      height: 28,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      flexShrink: 0,
                    }}
                  >
                    <span
                      style={{
                        color: "#C7B8A6",
                        fontSize: 20,
                        transform: industryOpen ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.22s ease",
                        lineHeight: 1,
                      }}
                    >
                      ˅
                    </span>
                  </div>
                </div>

                {industryOpen ? (
                  <div
                    style={{
                      position: "absolute",
                      top: `calc(100% + 10px)`,
                      left: 0,
                      width: "100%",
                      background: fieldBg,
                      border: fieldBorder,
                      borderRadius: 14,
                      boxSizing: "border-box",
                      maxHeight: 280,
                      overflowY: "auto",
                      boxShadow: "0 18px 40px rgba(0,0,0,0.28)",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {filteredIndustryOptions.length > 0 ? (
                        filteredIndustryOptions.map((item, index) => (
                          <div
                            key={index}
                            onClick={() => {
                              setIndustry(item);
                              setIndustryOpen(false);
                              setIndustrySearch("");
                            }}
                            style={{
                              width: "100%",
                              padding: "14px 14px",
                              borderBottom:
                                index !== filteredIndustryOptions.length - 1
                                  ? "1px solid rgba(247,148,29,0.12)"
                                  : "none",
                              color: "#D8D3CC",
                              fontSize: isMobile ? 16 : 17,
                              fontFamily: "Open Sans",
                              cursor: "pointer",
                              boxSizing: "border-box",
                              textAlign: "left",
                            }}
                          >
                            {item}
                          </div>
                        ))
                      ) : (
                        <div
                          style={{
                            padding: "14px",
                            color: "#9F9287",
                            fontSize: 15,
                            fontFamily: "Open Sans",
                            textAlign: "left",
                          }}
                        >
                          No industry found
                        </div>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>

              {/* ================= COUNTRY FIELD ================= */}
              <div
                style={{ width: "100%", position: "relative", marginTop: 18, zIndex: countryOpen ? 29 : 1 }}
                onClick={(e) => e.stopPropagation()}
              >
                <div
                  style={{
                    ...inputStyle,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    userSelect: "none",
                    position: "relative",
                    overflow: "hidden",
                  }}
                  onClick={() => {
                    if (!countryOpen) {
                      setCountryOpen(true);
                      setIndustryOpen(false);
                    }
                  }}
                >
                  {countryOpen ? (
                    <input
                      ref={countryInputRef}
                      placeholder="Search country"
                      value={countrySearch}
                      onChange={(e) => setCountrySearch(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        flex: 1,
                        height: "100%",
                        border: "none",
                        outline: "none",
                        background: "transparent",
                        color: "#EDEDED",
                        fontSize: isMobile ? 16 : 17,
                        fontFamily: "Open Sans",
                        paddingRight: 12,
                      }}
                    />
                  ) : (
                    <span
                      style={{
                        color: country ? fieldText : fieldPlaceholder,
                        fontSize: isMobile ? 16 : 17,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {country || "Country"}
                    </span>
                  )}

                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      setCountryOpen(!countryOpen);
                      if (!countryOpen) {
                        setIndustryOpen(false);
                      } else {
                        setCountrySearch("");
                      }
                    }}
                    style={{
                      minWidth: 28,
                      height: 28,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      flexShrink: 0,
                    }}
                  >
                    <span
                      style={{
                        color: "#C7B8A6",
                        fontSize: 20,
                        transform: countryOpen ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.22s ease",
                        lineHeight: 1,
                      }}
                    >
                      ˅
                    </span>
                  </div>
                </div>

                {countryOpen ? (
                  <div
                    style={{
                      position: "absolute",
                      top: `calc(100% + 10px)`,
                      left: 0,
                      width: "100%",
                      background: fieldBg,
                      border: fieldBorder,
                      borderRadius: 14,
                      boxSizing: "border-box",
                      maxHeight: 300,
                      overflowY: "auto",
                      boxShadow: "0 18px 40px rgba(0,0,0,0.28)",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {filteredCountryOptions.length > 0 ? (
                        filteredCountryOptions.map((item, index) => (
                          <div
                            key={index}
                            onClick={() => {
                              setCountry(item.name);
                              setPhoneCode(item.code);
                              setCountryOpen(false);
                              setCountrySearch("");
                            }}
                            style={{
                              width: "100%",
                              padding: "14px 14px",
                              borderBottom:
                                index !== filteredCountryOptions.length - 1
                                  ? "1px solid rgba(247,148,29,0.12)"
                                  : "none",
                              color: "#D8D3CC",
                              fontSize: isMobile ? 16 : 17,
                              fontFamily: "Open Sans",
                              cursor: "pointer",
                              boxSizing: "border-box",
                              display: "flex",
                              alignItems: "center",
                              gap: 10,
                              textAlign: "left",
                            }}
                          >
                            <span style={{ fontSize: 18 }}>{item.flag}</span>
                            <span
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {item.name}
                            </span>
                            <span style={{ marginLeft: "auto", color: "#B7A89B", flexShrink: 0 }}>
                              {item.code}
                            </span>
                          </div>
                        ))
                      ) : (
                        <div
                          style={{
                            padding: "14px",
                            color: "#9F9287",
                            fontSize: 15,
                            fontFamily: "Open Sans",
                            textAlign: "left",
                          }}
                        >
                          No country found
                        </div>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>

              <div style={labelTextStyle}>A little bit about you...</div>

              <div
                style={{
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                  gap: 16,
                }}
              >
                <input
                  placeholder="First Name"
                  style={inputStyle}
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />

                <input
                  placeholder="Last Name"
                  style={inputStyle}
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>

              <div
                style={{
                  ...inputStyle,
                  marginTop: 18,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: 10,
                }}
              >
                <span
                  style={{
                    color: "#B7A89B",
                    fontSize: isMobile ? 16 : 17,
                    fontFamily: "Open Sans",
                    whiteSpace: "nowrap",
                  }}
                >
                  ({phoneCode})
                </span>

                <input
                  placeholder="Phone Number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  style={{
                    flex: 1,
                    border: "none",
                    outline: "none",
                    background: "transparent",
                    color: fieldText,
                    fontSize: isMobile ? 16 : 17,
                    fontFamily: "Open Sans",
                  }}
                />
              </div>

              <button
                onClick={handleStepOneNext}
                style={{
                  width: "100%",
                  height: isMobile ? 58 : 62,
                  marginTop: 26,
                  border: "none",
                  borderRadius: 10,
                  backgroundColor: "#F7941D",
                  color: "#000000",
                  fontFamily: "Open Sans",
                  fontWeight: 700,
                  fontSize: isMobile ? 20 : 22,
                  cursor: "pointer",
                  boxSizing: "border-box",
                }}
              >
                Next
              </button>
            </>
          ) : (
            <>
              <div
                style={{
                  color: "#D8D8D8",
                  fontSize: isMobile ? 16 : 17,
                  fontWeight: 400,
                  fontFamily: "Open Sans",
                  lineHeight: "26px",
                }}
              >
                Get <span style={{ color: "#F7941D", fontWeight: 700 }}>7 days</span> free trial.
              </div>

              <div
                style={{
                  marginTop: 10,
                  color: "#FFFFFF",
                  fontSize: isMobile ? 34 : 42,
                  fontWeight: 700,
                  fontFamily: "Open Sans",
                  lineHeight: isMobile ? "42px" : "50px",
                }}
              >
                Hi {firstName || "Loram"}, 👋
              </div>

              <div
                style={{
                  marginTop: 10,
                  maxWidth: 520,
                  color: "#8F8A97",
                  fontSize: isMobile ? 16 : 18,
                  fontWeight: 400,
                  fontFamily: "Open Sans",
                  lineHeight: isMobile ? "28px" : "34px",
                }}
              >
                Before you get start quickly tell us a little about your
                organisation. This will help us create the right experience for
                you.
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  marginTop: isMobile ? 24 : 28,
                  marginBottom: isMobile ? 30 : 32,
                }}
              >
                <div
                  style={{
                    flex: 1,
                    height: 6,
                    borderRadius: 999,
                    background: "#F7941D",
                  }}
                />
                <div
                  style={{
                    flex: 1,
                    height: 6,
                    borderRadius: 999,
                    background: "#F7941D",
                  }}
                />
              </div>

              <input
                placeholder="Your Email"
                style={plainInputStyle}
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <div style={passwordInputWrapStyle}>
                <input
                  placeholder="Password"
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    outline: "none",
                    backgroundColor: "transparent",
                    color: "#6E6680",
                    fontSize: isMobile ? 18 : 19,
                    fontWeight: 400,
                    fontFamily: "Open Sans",
                  }}
                  type={show ? "password" : "text"}
                  value={pass}
                  onChange={(e) => setPass(e.target.value)}
                  onFocus={() => setShown(true)}
                  onBlur={() => setShown(false)}
                />

                <div
                  onClick={() => setShow(!show)}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: 10,
                    flexShrink: 0,
                  }}
                >
                  {show ? (
                    <FaRegEyeSlash size={20} color="#7C7A86" />
                  ) : (
                    <FaRegEye size={20} color="#7C7A86" />
                  )}
                </div>
              </div>

              {shown ? (
                <div
                  style={{
                    width: "100%",
                    marginTop: 14,
                    borderRadius: 12,
                    backgroundColor: "#DDF1F2",
                    border: "1px solid #2CC7C7",
                    padding: "14px 16px",
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                  }}
                >
                  <div
                    style={{
                      color: first ? "#111111" : "red",
                      fontSize: 13,
                      fontWeight: 400,
                      fontFamily: "Open Sans",
                    }}
                  >
                    Must be at least 7 characters
                  </div>

                  <div
                    style={{
                      color: second ? "#111111" : "red",
                      fontSize: 13,
                      fontWeight: 400,
                      fontFamily: "Open Sans",
                    }}
                  >
                    Must have at least 1 upper case character
                  </div>

                  <div
                    style={{
                      color: third ? "#111111" : "red",
                      fontSize: 13,
                      fontWeight: 400,
                      fontFamily: "Open Sans",
                    }}
                  >
                    Must have at least 1 lower case character
                  </div>

                  <div
                    style={{
                      color: four ? "#111111" : "red",
                      fontSize: 13,
                      fontWeight: 400,
                      fontFamily: "Open Sans",
                    }}
                  >
                    Must have at least 1 numeric character
                  </div>

                  <div
                    style={{
                      color: fifth ? "#111111" : "red",
                      fontSize: 13,
                      fontWeight: 400,
                      fontFamily: "Open Sans",
                    }}
                  >
                    Must have at least 1 special character
                  </div>
                </div>
              ) : null}

              <div style={passwordInputWrapStyle}>
                <input
                  placeholder="Confirm Password"
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    outline: "none",
                    backgroundColor: "transparent",
                    color: "#6E6680",
                    fontSize: isMobile ? 18 : 19,
                    fontWeight: 400,
                    fontFamily: "Open Sans",
                  }}
                  type={reshow ? "password" : "text"}
                  value={newpass}
                  onChange={(e) => setNewpass(e.target.value)}
                />

                <div
                  onClick={() => setReShow(!reshow)}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: 10,
                    flexShrink: 0,
                  }}
                >
                  {reshow ? (
                    <FaRegEyeSlash size={20} color="#7C7A86" />
                  ) : (
                    <FaRegEye size={20} color="#7C7A86" />
                  )}
                </div>
              </div>

              {newpass !== "" && pass !== newpass ? (
                <div
                  style={{
                    width: "100%",
                    marginTop: 12,
                    padding: "10px 14px",
                    borderRadius: 10,
                    background: "rgba(247,148,29,0.16)",
                    color: "#F7941D",
                    fontSize: 13,
                    fontFamily: "Open Sans",
                    boxSizing: "border-box",
                  }}
                >
                  Password does not match.
                </div>
              ) : null}

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 10,
                  marginTop: 18,
                }}
              >
                <input
                  type="checkbox"
                  checked={accept}
                  onChange={() => setAccept(!accept)}
                  style={{
                    width: 18,
                    height: 18,
                    marginTop: 3,
                    accentColor: "#F7941D",
                    cursor: "pointer",
                    flexShrink: 0,
                  }}
                />

                <div
                  style={{
                    color: "#D8D8D8",
                    fontSize: isMobile ? 14 : 15,
                    lineHeight: isMobile ? "24px" : "26px",
                    fontFamily: "Open Sans",
                  }}
                >
                  Agree to our{" "}
                  <span
                    onClick={() => {
                      const win = window.open(
                        "https://display.boomsoftware.co.uk/T",
                        "_blank"
                      );
                      if (win) win.focus();
                    }}
                    style={{
                      color: "#F7941D",
                      cursor: "pointer",
                      fontWeight: 700,
                    }}
                  >
                    Terms & Conditions
                  </span>
                </div>
              </div>

              <button
                onClick={handleFinalSubmit}
                style={{
                  width: "100%",
                  height: isMobile ? 58 : 62,
                  marginTop: 26,
                  border: "none",
                  borderRadius: 10,
                  backgroundColor: "#F7941D",
                  color: "#000000",
                  fontFamily: "Open Sans",
                  fontWeight: 700,
                  fontSize: isMobile ? 20 : 22,
                  cursor: "pointer",
                  boxSizing: "border-box",
                }}
              >
                Submit
              </button>

              <div
                onClick={() => setStep(1)}
                style={{
                  marginTop: 16,
                  color: "#F7941D",
                  fontSize: isMobile ? 15 : 16,
                  fontFamily: "Open Sans",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Back
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default connect(null, { SetId })(Free_trials);